import script from "./StrategyButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StrategyButton.vue?vue&type=script&setup=true&lang=js"

import "./StrategyButton.vue?vue&type=style&index=0&id=870e97c4&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-870e97c4"]])

export default __exports__